const config = {
    baseURL: "https://beatsbackend.onrender.com", // replace with your actual base URL
    apiEndpoint: "/api/v1",
  };
  
export default config;
  